import { Box } from '@chakra-ui/react';
import React from 'react';

const HourlyRateForm = ({ description, jobDetail }:{description: string, jobDetail: any}) => {
  return <Box>Coming soon!</Box>;
};

export default HourlyRateForm;
